import { MenuDataProps } from '@/components/AntdForm/antd-components.def.ts'
import { AccountBookOutlined, DollarOutlined } from '@ant-design/icons'
import { featureFlags } from '@/config/feature-flags'
import { ModuleFunction } from '@/features/auth/auth.def.ts'

export const routes = {
  login: '/login',
  logout: '/logout',
  invoicesAllocation: '/invoices-allocation',
  deferredBonuses: '/deferred-bonuses',
  notifications: '/notifications',
}

export const navMenuData: MenuDataProps[] = [
  ...(featureFlags.invoicesAllocation ? [{
    key: 'invoicesAllocation',
    url: routes.invoicesAllocation,
    label: 'Invoices Allocation',
    icon: <AccountBookOutlined />,
    children: [
      {
        key: 'submitInvoice',
        url: routes.invoicesAllocation,
        label: 'Submit Invoice',
      },
      {
        key: 'invoiceDrafts',
        url: `${routes.invoicesAllocation}/invoice-drafts`,
        label: 'Invoice Drafts',
      },
      {
        key: 'invoices',
        url: `${routes.invoicesAllocation}/invoices`,
        label: 'Invoices',
      },
      {
        key: 'productSubscriptionManagement',
        url: `${routes.invoicesAllocation}/product-subscription-management`,
        label: 'Product Subscription',
      },
      {
        key: 'fundAum',
        url: `${routes.invoicesAllocation}/fund-aum`,
        label: 'Fund AUM',
      },
    ],
    anyOfPermissions: [
      { moduleName: 'invoice-allocation', functionName: 'manage-invoice-details' },
      { moduleName: 'invoice-allocation', functionName: 'read-invoice-details' },
    ] satisfies ModuleFunction[],
  }] : []),
  ...(featureFlags.deferredBonuses ? [{
    key: 'deferredBonuses',
    url: routes.deferredBonuses,
    label: 'Deferred Bonuses',
    icon: <DollarOutlined />,
    children: [
      {
        key: 'deferredBonusesMain',
        url: routes.deferredBonuses,
        label: 'Deferred Bonuses',
      },
      {
        key: 'deferredBonusesEmployees',
        url: `${routes.deferredBonuses}/employees`,
        label: 'Employees',
      },
      {
        key: 'deferredBonusesFunds',
        url: `${routes.deferredBonuses}/funds`,
        label: 'Funds',
      },
      {
        key: 'vestingRules',
        url: `${routes.deferredBonuses}/vesting-rules`,
        label: 'Vesting Rules',
      },
      {
        key: 'allVestingDetails',
        url: `${routes.deferredBonuses}/all-vesting-details`,
        label: 'All Vesting Details',
      },
      {
        key: 'deferredBonusesChangeRequests',
        url: `${routes.deferredBonuses}/change-requests`,
        label: 'Change Requests',
      },
      {
        key: 'deferredBonusesAuditLog',
        url: `${routes.deferredBonuses}/audit-log`,
        label: 'Audit Log',
      },
      {
        key: 'deferredBonusesTypicalMonthSop',
        url: `${routes.deferredBonuses}/typical-month-sop`,
        label: 'Typical Month SOP',
      },
    ],
    requiredPermissions: [{ moduleName: 'deferred-bonus', functionName: 'manage-deferred-bonuses' }] satisfies ModuleFunction[],
  }] : []),
]
